export default __webpack_public_path__ + "static/media/select_image.b5d89bd6.svg";